import React from "react";
import { Container, Flex, useColorModeValue } from "@chakra-ui/react";
import Navbar from "../components/Navbar";
import Header from "../components/Header";
import ImageDetectionComponent from "../components/ImageDetectionComponent";

const Sealant = () => {
    return (
        <>
            <Header />
            <Navbar />
            <Container
                bgColor={useColorModeValue("gray.200", "blue.900")}
                maxW="full"
                mt={0}
                centerContent
                overflow="hidden"
                py={10}
            >
                <Flex direction="column" align="center" p={4}>
                    <ImageDetectionComponent apiUrl={`${process.env.REACT_APP_MOUTH_API}/segment_all?threshold=0.35`} title={"ตรวจจับฟัน"} />
                </Flex>
            </Container>
        </>

    );
};

export default Sealant;
